import { breakpoints } from '../components/breakpoints';

/**
 * Appointment form, display Hubspot calendar
 */
function showHubspotCalendar(meetingType) {
  const hubspotUrl =
    meetingType === 'in-person'
      ? 'https://meetings.hubspot.com/lescoursbellerive/rencontre-au-bureau-des-ventes'
      : 'https://meetings.hubspot.com/lescoursbellerive/rencontre-virtuelle';

  // const hubspotUrl = "https://meetings.hubspot.com/daniel-roch-lefebvre";

  $('.appointment-hubspot').slideUp(500, function () {
    $('.appointment-hubspot').html(
      `<div class="meetings-iframe-container" data-src="${hubspotUrl}?embed=true"></div><script type="text/javascript" src="https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js"></script>`
    );
    $('.appointment-hubspot').slideDown(500, function () {
      let scrollTop = $('.appointment-hubspot').offset().top;
      if ($(window).width() >= breakpoints.xl) {
        scrollTop -= $('.site-header').height();
      }
      $([document.documentElement, document.body]).animate(
        {
          scrollTop: scrollTop,
        },
        1000
      );
    });
  });
}

export default function contactAppointment() {
  if ($('.wp-block-group.appointment').length) {
    const $block = $('.wp-block-group.appointment');

    $block.append("<div class='appointment-hubspot'></div>");

    //Prevent page transition on button click
    $block.find('.wp-block-button.in-person a, .wp-block-button.virtual a').addClass('no-ajaxy');

    //In-person button
    $block.find('.wp-block-button.in-person a').on('click', function (e) {
      e.preventDefault();
      showHubspotCalendar('in-person');
    });

    //Virtual button
    $block.find('.wp-block-button.virtual a').on('click', function (e) {
      e.preventDefault();
      showHubspotCalendar('virtual');
    });
  }
}
